var _ellipse, _ellipse2, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionErrorDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 266,
    viewBox: "0 0 371 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 185.371,
    cy: 141.427,
    rx: 177.636,
    ry: 118.741,
    fill: "#798EBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_3390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 365,
    height: 257
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.6,
    cy: 133.795,
    rx: 182.138,
    ry: 128.158,
    transform: "rotate(-1.4725 185.6 133.795)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.543 135.508C101.894 137.672 86.6372 181.302 86.6372 181.302L32.1707 178.848L29.9247 140.37L17.5623 137.917L26.3906 118.642C29.6344 111.552 36.588 106.892 44.3777 106.578L69.2653 105.576L69.2656 105.585L80.298 105.132L101.8 104.267C102.023 104.258 102.242 104.265 102.464 104.265C103.313 106.049 111.722 118.712 112.992 120.298C112.992 120.298 112.011 129.403 104.543 135.508Z",
    fill: "#7CE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7527 88.5037C81.2892 85.1955 77.3011 87.7283 77.3011 87.7283L72.9412 87.2258C72.2271 86.1165 71.533 87.2825 70.122 87.3393C69.7589 87.3539 71.5462 91.9402 71.22 92.0484C70.6897 92.2219 67.318 82.4516 66.9277 82.8161C66.0718 81.6769 65.1991 79.9127 65.3515 77.5402C65.6262 73.0709 68.9535 73.3924 68.9535 73.3924C70.751 69.7949 79.4128 66.0963 85.9674 71.2974C92.5228 76.4976 88.656 83.1423 88.656 83.1423L78.5533 83.549",
    fill: "#01050C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0548 174.137L89.3143 171.832L131.457 219.941C134.981 223.832 136.846 228.942 136.656 234.185L133.528 320.241L115.42 320.97L113.886 235.068L76.144 188.696L54.305 189.575L47.4036 323.708L29.2947 324.437L32.0548 174.137Z",
    fill: "#042451"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4817 96.1452L79.8954 95.1397L80.2977 105.133L69.2653 105.585L68.6109 89.3297C66.9917 88.9379 65.7529 87.5264 65.6825 85.7762C65.6354 84.6069 66.1219 83.5517 66.9271 82.8167C67.3174 82.4522 67.7855 82.1722 68.3158 81.9988C68.642 81.8906 68.9859 81.8098 69.349 81.7952C70.7601 81.7384 72.0124 82.4608 72.7265 83.5701L78.2898 77.02C78.2898 77.02 81.0892 80.2415 78.5527 83.5497L88.6554 83.143L89.0208 92.2184C89.1201 94.6857 86.9012 96.6016 84.4817 96.1452Z",
    fill: "#E4B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.015 126.379C-80.1588 120.535 -26.0644 109.395 15.4655 111.583C56.9954 113.77 103.939 121.234 125.097 125.835",
    stroke: "#579D96",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.332,
    cy: 125.515,
    rx: 13.6673,
    ry: 13.6212,
    transform: "rotate(11.4429 123.332 125.515)",
    fill: "#3E706B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.436 124.664C111.609 157.107 145.9 175.441 163.09 178.734L180.927 100.837C163.736 94.0485 127.013 100.49 120.436 124.664Z",
    fill: "#579D96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.898,
    cy: 139.215,
    rx: 14.3505,
    ry: 39.9181,
    transform: "rotate(11.2445 170.898 139.215)",
    fill: "#70CAC1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.31667,
    ry: 6.4912,
    transform: "matrix(0.980792 0.195055 -0.173914 0.984761 174.699 125.024)",
    fill: "#3E706B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.31667,
    ry: 6.4912,
    transform: "matrix(0.980792 0.195055 -0.173914 0.984761 169.7 155.032)",
    fill: "#3E706B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1635 109.523L101.012 117.718L125.489 139.93C127.203 141.489 128.528 143.406 129.394 145.514C129.943 146.854 130.312 148.279 130.47 149.738C131.066 155.275 126.895 160.165 121.381 160.387C117.911 160.527 114.637 158.747 112.839 155.743L94.5827 125.278L83.5341 114.489L91.0104 106.312L99.1635 109.523Z",
    fill: "#E4B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7819 137.095L17.8182 136.161L66.134 118.166L74.821 112.591L81.802 117.178L83.385 128.36L77.7068 129.141L68.7339 130.364L35.5611 146.741L31.4994 148.742C25.1946 151.849 17.4794 145.298 17.7819 137.095Z",
    fill: "#E4B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.867 150.329L319.305 127.28C316.405 122.365 311.05 119.442 305.369 119.67L261.454 121.438C255.607 121.674 250.405 125.187 247.993 130.521L236.794 155.293C236.254 156.495 235.99 157.806 236.043 159.124L236.073 159.883C236.236 163.92 239.053 167.531 243.021 168.24C246.625 168.884 250.133 167.164 251.866 164.094L257.743 153.724L262.057 177.277L308.955 175.389L311.912 146.108L319.714 158.437L319.323 192.97L330.581 192.517L334.293 156.882C334.518 154.601 334.033 152.304 332.867 150.329Z",
    fill: "#7CE0D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.057 177.277L239.321 307.313L252.4 310.845L281.907 194.18L290.392 193.839L306.483 308.223L320.016 307.678L308.955 175.389L262.057 177.277Z",
    fill: "#042451"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.323 192.97L315.94 196.678L319.747 203.125L330.1 202.708L330.581 192.517L319.323 192.97Z",
    fill: "#E4B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.773 101.783C287.496 100.169 286.167 99.0125 284.62 98.8464C284.302 98.8124 283.97 98.8046 283.64 98.8632C282.95 98.9817 282.329 99.3031 281.849 99.7459C279.093 98.4036 277.795 95.4087 277.795 95.4087L266.231 103.606L267.685 111.983C268.078 114.255 270.471 115.571 272.593 114.678L276.581 112.86L277.941 120.775L288.339 120.356L285.798 105.607C287.19 104.931 288.049 103.398 287.773 101.783Z",
    fill: "#E4B9AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.046 93.58C313.805 91.1524 310.33 89.9509 307.076 90.4947C305.352 90.7834 303.51 91.5109 301.939 90.7469C300.507 90.0484 299.897 88.3808 298.998 87.0575C296.959 84.0304 292.841 82.5978 289.354 83.709C286.94 84.4822 284.372 87.0626 283.471 89.8103C281.15 88.7635 278.526 88.4442 276.037 88.8741C270.086 89.903 262.142 93.9097 266.23 103.606L277.795 95.4087C277.795 95.4087 279.093 98.4036 281.848 99.7459C282.329 99.3032 282.95 98.9818 283.639 98.8633C283.969 98.8046 284.301 98.8124 284.62 98.8465C286.166 99.0126 287.496 100.169 287.772 101.783C288.048 103.398 287.189 104.931 285.798 105.607L286.628 110.484C286.628 110.484 291.364 105.905 290.084 98.4798C289.595 95.6898 288.344 93.4945 286.634 91.8953C288.627 91.5338 290.56 91.5468 292.682 92.8964C294.542 94.0888 295.884 95.9311 297.398 97.5457C299.227 99.4894 301.361 101.141 303.692 102.419C306.362 103.876 309.466 104.857 312.444 104.23C315.423 103.602 318.11 100.976 318.002 97.9321C317.952 96.307 317.136 94.7792 316.046 93.58Z",
    fill: "#01050C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.666 148.946C261.77 150.916 294.46 150.331 328.378 132.234C370.775 109.614 399.095 76.6914 412.334 28.8477C425.572 -18.996 426.42 -30.0363 437.114 -44.7591",
    stroke: "#579D96",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.45 145.734C254.176 176.501 227.892 182.039 214.659 180.962L218.605 109.641C225.752 108.378 252.724 114.967 253.45 145.734Z",
    fill: "#579D96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.573,
    y: 152.682,
    width: 27.6614,
    height: 8.42519,
    rx: 4.2126,
    transform: "rotate(6.04077 177.573 152.682)",
    fill: "#3E706B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.468,
    y: 121.59,
    width: 27.6614,
    height: 8.42519,
    rx: 4.2126,
    transform: "rotate(6.04077 182.468 121.59)",
    fill: "#3E706B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.112,
    y: 103.358,
    width: 20.4231,
    height: 79.4151,
    rx: 4,
    transform: "rotate(7.20896 205.112 103.358)",
    fill: "#70CAC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.295 152.339L249.77 142.003L260.003 141.591L261.743 151.838L255.699 156.545L249.295 152.339Z",
    fill: "#E4B9AB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.564 109.605C276.564 108.339 277.419 105.521 280.839 104.381",
    stroke: "#01050C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2799 88.2603C74.5241 88.0232 77.4524 88.3355 79.2124 91.4813",
    stroke: "#01050C",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionErrorDark);
export default __webpack_public_path__ + "static/media/connection-error-dark.e3fb9a3bda478432fa5d0f45c8300b61.svg";
export { ForwardRef as ReactComponent };